// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
//
const firebaseConfig = {
    apiKey: "AIzaSyClfLE2TSJp61ikKs8hNVWBOWWjIuCf6F0",
    authDomain: "corporacioncessa-ef503.firebaseapp.com",
    projectId: "corporacioncessa-ef503",
    storageBucket: "corporacioncessa-ef503.firebasestorage.app",
    messagingSenderId: "679429351040",
    appId: "1:679429351040:web:3c505d63595222d6abe865",
    measurementId: "G-HZPCH0MY7R"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)